// ═══════════════════════════════════════════════════════════════════════════
// audit.js — client wrapper for the admin audit log (migration 071).
//
// logAdminAction() is fire-and-forget: it never throws into the calling admin
// action, so a logging hiccup can't block the actual operation. Server-side
// the RPC records the caller's real identity and ignores non-admins.
// ═══════════════════════════════════════════════════════════════════════════

import { supabase } from './supabase';

/** Record an admin action. Fire-and-forget — failures are swallowed. */
export function logAdminAction(action, { targetType = null, targetId = null, detail = {} } = {}) {
  if (!supabase || !action) return;
  try {
    supabase.rpc('log_admin_action', {
      p_action: action,
      p_target_type: targetType,
      p_target_id: targetId != null ? String(targetId) : null,
      p_detail: detail || {},
    }).then(() => {}, () => {});
  } catch { /* never blocks the caller */ }
}

/** Recent audit entries (newest first). CMS access required server-side. */
export async function listAuditLog(limit = 100) {
  if (!supabase) return [];
  try {
    const { data, error } = await supabase.rpc('admin_list_audit_log', { p_limit: limit });
    if (error) throw new Error(error.message);
    if (data?.error) throw new Error(data.error);
    return data?.entries || [];
  } catch (e) {
    throw e;
  }
}
